var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"left_bg col-sm-2 col-2 h-100 text-white py-2 d-flex align-items-center justify-content-center fixed-top"}),_c('div',{staticClass:"col offset-2 offset-sm-2 offset-lg-2 pl-0 pr-0 bg-white rightside_section"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }